import { Box, Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import SearchIcon from '@/icons/Search';
import { useRef } from 'react';
import debounce from 'lodash/debounce';

export const Search = ({ onSearch = () => {} }) => {
  const userInput = useRef();

  const OnSearch = debounce(() => {
    onSearch(userInput?.current?.value);
  }, 300);

  return (
    <Box p="12px 22px">
      <InputGroup>
        <Input
          ref={userInput}
          color="secondary-500"
          _placeholder={{ opacity: 1, color: 'secondary-500' }}
          placeholder="Search Blueprint"
          onChange={OnSearch}
          w="450px"
        />
        <InputRightElement
          pointerEvents="none"
          children={<SearchIcon color="#8D8D8D" />}
        />
      </InputGroup>
    </Box>
  );
};
